export enum AccessToken {
  DEVELOPER = 'developerAccessToken',
  PORTAL = 'portalAccessToken',
}
